import * as React from 'react';
import {
  Navigate,
  useParams,
  useLocation,
  useSearchParams
} from 'react-router-dom';
import { Overlay } from 'rcd-cpp-ui/ui/loader';
import { HomeWorkspaceModal } from '../HomeWorkspaceModal/homeWorkspaceModal';
import { useSelector } from '../../utils/useSelector';
import { useActions } from '../ContentPlanning/contentPlanningActions';
import { Page } from '../Page/page';
import URLManager from '../../utils/urlManager';

export const ItemHome = () => {
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const { loadWorkspaces } = useActions();
  const [workspaceInfo, setWorkspaceInfo] = React.useState(null);
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const refId = params.refId;
  const commentParam = searchParams.get('c');
  const dataType = searchParams.get('dataType');
  const isExpiryDashboard = location.pathname
    .toLowerCase()
    .split('/')
    .includes('expirydashboard');

  const loadWorkspaceInfo = React.useCallback(async () => {
    if (getAPI) {
      const { getHomeWorkspace } = getAPI();
      const wsInfo = await getHomeWorkspace(refId, dataType);
      setWorkspaceInfo(wsInfo);

      if (!wsInfo?.homeWorkspaceRefId && !wsInfo?.userWorkspaceId) {
        loadWorkspaces();
      }
    }
  }, [getAPI, refId, dataType]);

  React.useEffect(() => {
    loadWorkspaceInfo();
  }, [loadWorkspaceInfo]);

  if (!workspaceInfo) return <Overlay />;

  if (!workspaceInfo?.userWorkspaceId) {
    return (
      <Page>
        <HomeWorkspaceModal onSave={() => loadWorkspaceInfo()} />
      </Page>
    );
  }

  return (
    <Navigate
      to={URLManager.generateUrl(
        workspaceInfo?.homeWorkspaceRefId || workspaceInfo?.userWorkspaceId,
        {
          v: isExpiryDashboard
            ? workspaceInfo.expiryDashboardRefId
            : workspaceInfo.viewRefId,
          id: workspaceInfo.refId || refId,
          c: commentParam
        }
      )}
      replace
    />
  );
};
